export enum ModeDePaiement {
  CHQ = "CHQ",
  VIR = "VIR",
  CB = "CB",
}
